import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Privacy = () => {
    return (
        <div className="landing-page">
            <main className="policy-content" style={{ paddingTop: '120px', paddingBottom: '100px', maxWidth: '800px', margin: '0 auto', paddingLeft: '7.6923%', paddingRight: '7.6923%' }}>
                <Link to="/" className="back-link" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '40px' }}>
                    <ArrowLeft size={20} />
                    Back to Home
                </Link>

                <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '40px' }}>Privacy Policy</h1>

                <div className="policy-text" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                    <p style={{ marginBottom: '20px' }}>Last Updated: January 8, 2026</p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>1. Introduction</h2>
                    <p style={{ marginBottom: '20px' }}>
                        Adjactive ("we," "our," or "us"), an initiative by Hakxcore, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website and use our AI security services.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>2. Information Collection</h2>
                    <p style={{ marginBottom: '20px' }}>
                        We collect information that you provide directly to us through forms, email communication, and service requests. This may include your name, work email address, company name, and details regarding your AI implementation.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>3. Use of Information</h2>
                    <p style={{ marginBottom: '20px' }}>
                        We use the information we collect to:
                    </p>
                    <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                        <li>Provide, maintain, and improve our services.</li>
                        <li>Respond to your inquiries and requests.</li>
                        <li>Send technical notices, updates, and security alerts.</li>
                        <li>Comply with legal obligations and industry standards.</li>
                    </ul>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>4. Data Security</h2>
                    <p style={{ marginBottom: '20px' }}>
                        We implement appropriate technical and organizational measures to protect your data against unauthorized access, loss, or alteration. As an AI security company, we maintain rigorous internal security standards.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>5. Contact Us</h2>
                    <p style={{ marginBottom: '20px' }}>
                        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:tech@adjactive.com" style={{ color: 'var(--brand-primary)' }}>tech@adjactive.com</a>.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default Privacy;
